// @ts-nocheck
import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import { Helmet } from 'react-helmet';
import { useStores } from 'hooks/useStores';
import { useSearchParams } from 'react-router-dom';
import LkOrders from '../../components/lk/lkOrders';
import LkPersonal from '../../components/lk/lkPersonal';
import { LoyaltyProgram } from '../../components/lk/LoyaltyProgram';
import { GiftCabinet } from '../../components/lk/GiftCabinet';
import Seo from 'components/Seo';

import '../../styles/lk.css';

const personalAccountTabs = {
  orders: 'Мои заказы',
  personalData: 'Персональные данные',
  giftCabinet: 'Кабинет подарков',
  loyaltyProgram: 'Программа лояльности',
};

const LK = () => {
  const [context, setContext] = useState({});
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedTab, setSelectedTab] = useState('orders');
  const containerRef = useRef(null);
  const { api } = useStores();
  const { userStore } = useStores();
  const { getUser } = userStore;

  const handleTabClick = (tabKey) => {

    setSearchParams({ tab: tabKey });
  };

  useEffect(() => {
    api.content.getPageApi('lk').then((response) => {
      setContext(response.init_state.object);
    });
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, []);

  const SelectedTab = () => {
    switch (selectedTab) {
      case 'orders':
        return <LkOrders />;
      case 'personalData':
        return <LkPersonal />;
      case 'loyaltyProgram':
        return <LoyaltyProgram />;
      case 'giftCabinet':
        return <GiftCabinet />;
      default:
        return null;
    }
  };

  useEffect(() => {
    const currentTub = searchParams.get('tab') || 'orders'

    setSelectedTab(currentTub);

    return () => {
      searchParams.delete('tab');
    };
  }, [searchParams]);

  useEffect(() => {
    (async () => {
      await getUser();
    })();
  }, []);

  return (
    <main>
      <section className="lk">
        <div className="lk-wrap">
          <Seo seo={context} />

          <div className="lk-tabs" ref={containerRef}>
            <div className="lk-tabs__container">
              {Object.entries(personalAccountTabs).map(([tabKey, tabName]) => (
                <a
                  key={tabKey}
                  onClick={() => handleTabClick(tabKey)}
                  className={classNames({
                    'lk-tabs__item': true,
                    [`lk-tabs__item--${tabKey}`]: true,
                    'lk-tabs-active': tabKey === selectedTab,
                  })}
                >
                  <h2>{tabName}</h2>
                </a>
              ))}
            </div>
          </div>
          {SelectedTab()}
        </div>
      </section>
    </main>
  );
};

export default LK;
